import { capitalize } from '../util';

/**
 * App\Enum\WorkDoneCategory, in the order the menus offer them.
 */
export const ALL = [
  'tech_updates',
  'error_investigation',
  'release_creation',
  'client_comms',
  'internal_comms',
  'design',
  'growth',
] as const;

/**
 * A project's own time only ever covers its design; everything else it takes
 * belongs to one of its service orders.
 */
export const FOR_PROJECT: ReadonlyArray<string> = ['design'];

export function format(category: string): string {
  return capitalize(category.replace(/_/g, ' '));
}
